<script>
import { defineComponent } from "vue";
import { Bar } from "vue-chartjs";

export default defineComponent({
  name: "barChart",
  extends: Bar,
  props: ["data"],
  data() {
    return {
      options: {
        tooltips: {
          intersect: false,
          displayColors: false,
          mode: "index",
        },
        responsive: true,
        maintainAspectRatio: false,
        barRoundness: 0.6,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 10,
                fontColor: "#6C757D",
                maxTicksLimit: 4,
                suggestedMin: 3,
                padding: 10,
              },
              gridLines: {
                drawTicks: false,
                drawBorder: true,
                display: false,
                offsetGridLines: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                maxRotation: 0,
                fontSize: 10,
                fontColor: "#6C757D",
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
});
</script>
